export var LOADING_FLAT = '...';

// 只要 start with 这个，就可以判断为 function message
export var FUNCTION_MESSAGE_FLAG = '{"function';